import WebFont from 'webfontloader'

const options = {"custom":{"urls":["https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Crete+Round:400,400i&amp;subset=latin-ext&display=swap","https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Maven+Pro:wght@400..900&display=swap","https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Maven+Pro:wght@400..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"]}}

WebFont.load(options)
